import React, {useEffect} from 'react';
import {ActionModal, ErrorModal, FormInput, useErrorHandler} from '../../../../shared';
import {useEditAppealStoryForm} from '../../model';
import {DatePicker} from '@gravity-ui/date-components';
import styles from './EditAppealStoryModal.module.scss';
import {Text} from '@gravity-ui/uikit';

interface EditAppealStoryModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  appealId: string;
  storyId: string | null;
}

const FORMAT = 'DD.MM.YYYY';

export const EditAppealStoryModal = ({open, setOpen, appealId, storyId}: EditAppealStoryModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleDateChange,
    isLoading,
    submitError,
    resetForm,
    submitForm,
  } = useEditAppealStoryForm({appealId, storyId, setOpen});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'История сбора',
    title: 'Ошибка при редактировании истории сбора',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open, resetForm]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактировать историю сбора'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Заголовок истории"
          placeholder="Заголовок истории"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />
        <div className={styles.datePicker}>
          <Text variant="subheader-1" className={styles.label}>
            Дата истории<span style={{color: 'red'}}>*</span>
          </Text>
          <DatePicker
            className={styles.datePickerInput}
            onUpdate={handleDateChange}
            size="xl"
            value={values.date}
            placeholder="Выберите дату"
            format={FORMAT}
          />
        </div>
        <FormInput
          label="Приоритет"
          placeholder="Приоритет"
          name="priority"
          type="number"
          value={values.priority.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.priority && errors.priority}
        />
      </ActionModal>
      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
